<template>
  <form @submit.prevent="onSubmit" @reset="onReset" :class="[baseCss]" :method="method.toLowerCase()" :action="action" :novalidate="novalidate" :name="name" :enctype="enctype" :accept-charset="acceptCharset" :autocomplete="autocomplete">
    <slot />
  </form>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'AsyncForm',
  mixins: [
    methods
  ],
  data () {
    return {
      baseCss: this.componentBaseCss('async-form')
    }
  },
  props: {
    formData: {
      type: Object,
      required: true,
      default: () => {}
    },
    validate: {
    },
    method: {
      type: String,
      default: 'GET'
    },
    autocomplete: {
      type: String,
      default: 'on',
      validator: value => {
        return ['on', 'off'].includes(value)
      }
    },
    action: {
      type: String
    },
    novalidate: {
      type: String,
      validator: value => {
        return ['novalidate'].includes(value)
      }
    },
    enctype: {
      type: String,
      default: 'application/x-www-form-urlencoded',
      validator: value => {
        return ['text/plain', 'application/x-www-form-urlencoded', 'multipart/form-data'].includes(value)
      }
    },
    acceptCharset: {
      type: String
    },
    name: {
      type: String
    }
  },
  methods: {
    onSubmit () {
      if (!this.validate) {
        this.$emit('submit', this.formData)
      }
    },
    onReset () {
      this.$emit('reset')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/bcq-ui/components/async-form/async-form.vue